webpackJsonp([142629428675168],{

/***/ 633:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"facebook":{"appId":"3408220195885721"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-6ccaacdece6306e1e979.js